import { TextFieldModule } from "@angular/cdk/text-field";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { AnnotationModule } from "src/app/annotation/annotation.module";
import { ImageEditorComponent } from "./components/image-editor/image-editor.component";
import { TextboxEditorComponent } from "./components/image-editor/textbox/textbox-editor/textbox-editor.component";
import { OutsideUnitBaseComponent } from "./components/outside-unit-base.component";
import { DebounceClickDirective } from "./components/photo-and-remark/debounce-clicker/debounce-clicker.directive";
import { FullscreenPhotoComponent } from "./components/photo-and-remark/fullscreen-photo/fullscreen-photo.component";
import { MultiDeleteComponent } from "./components/photo-and-remark/multi-delete/multi-delete.component";
import { PhotoAndRemarkComponent } from "./components/photo-and-remark/photo-and-remark.component";
import { SliderComponent } from "./components/slider/slider.component";
import { SurveyFrameListTemplateComponent } from "./survey-frame-list/survey-frame-list-template/survey-frame-list-template.component";
import { SurveyFrameListComponent } from "./survey-frame-list/survey-frame-list.component";
import { TooltipModule } from "primeng/tooltip";
import { SurveyFrameTabTemplateComponent } from "./survey-frame-list/survey-frame-tab-template/survey-frame-tab-template.component";
import { SurveyAbstractComponent } from "./components/survey-abstract/survey-abstract.component";
import { ContactFormComponent } from "./components/contact-form/contact-form.component";
import { DropdownModule } from "primeng/dropdown";
import { ContactSearchComponent } from "./components/contact-search/contact-search.component";
import { FormValidationService } from "./services/formValidation.service";
import { MatMenuModule } from "@angular/material/menu";

@NgModule({
  declarations: [
    SurveyFrameListComponent,
    SurveyFrameListTemplateComponent,
    PhotoAndRemarkComponent,
    OutsideUnitBaseComponent,
    DebounceClickDirective,
    SliderComponent,
    ImageEditorComponent,
    TextboxEditorComponent,
    MultiDeleteComponent,
    FullscreenPhotoComponent,
    SurveyFrameTabTemplateComponent,
    SurveyAbstractComponent,
    ContactFormComponent,
    ContactSearchComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgbNavModule,
    ToastModule,
    SharedModule,
    ReactiveFormsModule,
    AnnotationModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    TextFieldModule,
    TooltipModule,
    DropdownModule,
  ],
  entryComponents: [],
  exports: [
    SurveyFrameListComponent,
    SurveyFrameListTemplateComponent,
    PhotoAndRemarkComponent,
    ImageEditorComponent,
    SurveyFrameTabTemplateComponent,
    ContactFormComponent,
    ContactSearchComponent,
  ],
  providers: [FormValidationService],
})
export class SharedSurveyModule {}
